module.exports = __webpack_public_path__ + "img/FC1.df3178c7.png";